import {Base} from "@/api/Base"

export class ReportList extends Base {
    path = "report/list"
}